import React from "react";
import { useWeb3 } from "../context/Web3Context";
import { useToast } from "./common/Toast";
import { parseError } from "../utils/errors";
import { APP_NAME } from "../config/app.config";
import Welcome from "./Welcome";

export default function ConnectWallet() {
  const { connect, connecting, hasWallet } = useWeb3();
  const toast = useToast();

  const onConnect = async () => {
    if (!hasWallet) {
      toast.error("No wallet detected. Open this page in Trust Wallet / MetaMask in-app browser.");
      return;
    }
    try {
      await connect();
      toast.success("Wallet connected.");
    } catch (e) {
      toast.error(parseError(e));
    }
  };

  return (
    <main className="app-content">
      <div className="stack">
        {/* connect CTA on top */}
        <div className="card center fade-up connect-cta">
          <img src="/logo.png" alt={APP_NAME} className="connect-logo" />
          <h1 style={{ margin: "4px 0" }}>{APP_NAME}</h1>
          <p className="muted" style={{ marginTop: 6 }}>
            Own a fraction of a node. Earn on-chain income. Hold the SCN token.
          </p>
          <button className="btn btn-block mt-4" onClick={onConnect} disabled={connecting}>
            {connecting ? "Connecting…" : "Connect Wallet"}
          </button>
          {!hasWallet && (
            <p className="muted mt-3" style={{ fontSize: 13 }}>
              On mobile, open this site from inside your wallet app's browser.
            </p>
          )}
        </div>

        {/* full marketing content */}
        <Welcome />

        {/* secondary connect at bottom */}
        <button className="btn btn-block" onClick={onConnect} disabled={connecting}>
          {connecting ? "Connecting…" : "Connect Wallet to Start"}
        </button>
      </div>
    </main>
  );
}
